// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__D3ja9","control":"Checkout_control__cII5N","actions":"Checkout_actions__MSCRc","submit":"Checkout_submit__GizHz","invalid":"Checkout_invalid__reJka"};